<div class="main-page">

  <!-- Search bar -->
  <div class="main-page-search-row">
    <ion-item lines="none" color="none" class="main-page-search-item">
      <ion-searchbar
        class="search"
        [placeholder]="'Search by report name, description or category...' | translate"
        (ionInput)="onSearch($event)"
        show-clear-button="focus"
      ></ion-searchbar>
    </ion-item>
  </div>

  <!-- Search results -->
  @if (searchQuery) {
    @if (showLoadingReports) {
      <ion-spinner name="circular" class="spinner"></ion-spinner>
    }
    @if (!showLoadingReports) {
      <!-- Matching sections -->
      @if (filteredSections.length > 0) {
        <ion-title class="dashboard-section-title">{{ 'Categories' | translate }}</ion-title>
        <div class="sections-grid search-sections">
          <div class="sections-grid-inner">
            @for (section of filteredSections; track section) {
              <app-section-card
                [collapsableTitle]="section.collapsableTitle"
                [collapsableTitleId]="section.collapsableTitleId"
                [description]="section.description"
                [subTitles]="section.subTitles"
                [sectionLogo]="section.sectionLogo"
                [logoColor]="section.logoColor"
              ></app-section-card>
            }
          </div>
        </div>
      }
      <!-- Matching reports & embeds -->
      @if (filteredReports.length > 0 || filteredEmbeds.length > 0) {
        <ion-title class="dashboard-section-title">{{ 'Reports' | translate }}</ion-title>
      }
      @if (filteredReports.length > 0) {
        <div class="search-results">
          <div class="search-results-inner">
            @for (item of filteredReports; track item) {
              <div class="search-result-card">
                <app-report-card
                  [report]="item.report"
                  [groupId]="item.group?.GroupID ?? item.report.Groups?.[0]?.GroupID"
                  [group]="item.group"
                  [collapsableTitle]="item.collapsableTitle"
                ></app-report-card>
              </div>
            }
          </div>
        </div>
      }
      @if (filteredEmbeds.length > 0) {
        <div class="search-results">
          <div class="search-results-inner">
            @for (item of filteredEmbeds; track item) {
              <div class="search-result-card">
                <app-embed-dashboard-card
                  [embed]="item.embed"
                  [collapsableTitle]="item.collapsableTitle"
                  [collapsableTitleId]="item.collapsableTitleId"
                  returnUrl="/home"
                ></app-embed-dashboard-card>
              </div>
            }
          </div>
        </div>
      }
      @if (filteredSections.length === 0 && filteredReports.length === 0 && filteredEmbeds.length === 0) {
        <div class="main-page-no-results">
          <ion-icon name="search-outline" class="main-page-no-results-icon"></ion-icon>
          <p>{{ 'No categories/reports found matching your search.' | translate }}</p>
        </div>
      }
    }
  } @else {
    @if (showLoadingReports || showLoadingRole || showLoadingData) {
      <ion-spinner name="circular" class="spinner"></ion-spinner>
    }
    @if (!showLoadingReports && !showLoadingRole && !showLoadingData) {
      <div class="sections-grid">
        <div class="sections-grid-inner">
          @for (section of sections; track section) {
            <app-section-card
              [collapsableTitle]="section.collapsableTitle"
              [collapsableTitleId]="section.collapsableTitleId"
              [description]="section.description"
              [subTitles]="section.subTitles"
              [sectionLogo]="section.sectionLogo"
              [logoColor]="section.logoColor"
            ></app-section-card>
          }
        </div>
      </div>
      <br>
        <div class="main-page-footer">
          <span class="footer-line"></span>
          <ion-button routerLink="/home/help-pages" color="secondary" class="main-page-see-all-btn">
            {{ 'Help Page' | translate }}
            <ion-icon name="help-circle-outline" slot="end"></ion-icon>
          </ion-button>
          <ion-button routerLink="/home/favorites" color="secondary" class="main-page-favourites-btn">
            {{ 'Favorites' | translate }}
            <ion-icon name="star-outline" slot="end"></ion-icon>
          </ion-button>
          <ion-button routerLink="/home/all-reports" color="secondary" class="main-page-see-all-btn">
            {{ 'All reports' | translate }}
            <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
          </ion-button>
          <span class="footer-line"></span>
        </div>
      }
    }

    <!-- Section cards (default view) -->
  </div>
